import { useTranslation } from "react-i18next";
import { PreferenceLine } from "../../preferenceLine";
import { OpeningHours } from "@/types/forms/auth/registerFormData.form";
import { OpeningHoursDisplay } from "@/components/pickUpLocation/OpeningHoursDisplay";

type PickupEntityGroupProps = {
  name: string;
  street: string;
  postalCode: string;
  city: string;
  contactNumber: string;
  contactNumber2: string;
  openingHours: OpeningHours;
};

export const PickupEntityGroup = ({
  name,
  street,
  postalCode,
  city,
  contactNumber,
  contactNumber2,
  openingHours,
}: PickupEntityGroupProps) => {
  const { t } = useTranslation("boClients");
  return (
    <div className="flex flex-col gap-0">
      <PreferenceLine title={t("profilePickupEntityGroup.nameLabel")} value={[name]} />
      <PreferenceLine
        title={t("profilePickupEntityGroup.pickupAddressLabel")}
        value={[
          t("profilePickupEntityGroup.addressStreet", { street }),
          t("profilePickupEntityGroup.addressCity", { postalCode, city }),
        ]}
      />
      <PreferenceLine
        title={t("profilePickupEntityGroup.contactNumberLabel")}
        value={[contactNumber]}
      />
      <PreferenceLine
        title={t("profilePickupEntityGroup.contactNumber2Label")}
        value={[contactNumber2 !== "+33" ? contactNumber2 : ""]}
      />
      <div className="flex flex-col items-start justify-between border-0 border-b border-gray-200 py-4 sm:flex-row sm:items-start">
        <div className="flex flex-1 flex-col">
          <p className="text-sm font-medium text-gray-600">
            {t("profilePickupEntityGroup.openingHoursLabel")}
          </p>
        </div>
        <div className="flex flex-1 flex-col">
          <OpeningHoursDisplay openingHours={openingHours} />
        </div>
      </div>
    </div>
  );
};
